import sileo from 'sileo';

const PCN = new sileo.Model('hqzen', 'employee-pcns');
const EmploymentPCNDetails = new sileo.Model('hqzen', 'employment-pcn-details');

const actions = {
    fetchEmployeePCNs(context, filters) {
        return PCN.objects.filter(filters);
    },

    fetchEmploymentPCNDetails(context, pk) {
        return EmploymentPCNDetails.objects.get(pk);
    },

    async acknowledgePCN(context, payload) {
        let pk = payload.pk;
        let signature = payload.signature_file;
        let formData = new FormData();
        return new Promise((resolve, reject) => {
            signature.save(async(blob) => {
                formData.append('signature_file', blob, 'signature.png');
                delete payload.signature;
                delete payload.pk;
                for (let key in payload) {
                    formData.append(key, payload[key]);
                }
                resolve(await EmploymentPCNDetails.objects.update({ pk }, formData));
            });
        });
    }
};

export default {
    namespaced: true,
    actions
};
